export const IS_PRODUCTION = process.env.REACT_APP_MODE?.toLowerCase() === 'production';
export const API_PATH = IS_PRODUCTION ? 'https://metaz.io/api/v1/' : 'https://metaz.rocknblock.io/api/v1/';
